<template>
  <div class="home">
    <Slider title="We provide a well-driven solution to your problems" />
    <div class="home__body">
      <div class="home__body__offers">
        <p class="home__body__offers-title my-11">What we offer</p>
        <div
          class=" mx-10 place-content-center grid grid-rows-4 md:grid-rows-2 lg:grid-rows-1 grid-flow-col gap-4"
        >
          <a @click="goToRoute('Recruitment')">
            <InfoCaret
              :image="imageList[0]"
              title="Recruitment"
              message="We provide skilled and well trained professionals"
            />
          </a>
          <a>
            <InfoCaret :image="imageList[3]" title="E-Commerce" />
          </a>
          <a @click="goToRoute('Publishing')">
            <InfoCaret
              :image="imageList[1]"
              title="Publishing"
              message="We are in collaboration with great marketing platforms"
            />
          </a>
          <a>
            <InfoCaret
              :image="imageList[2]"
              title="Import & Export"
              message="Trust us for your distribution of groceries and logistics"
            />
          </a>
        </div>
      </div>
      <div class="home__body__text my-16">
        <p class="mt-6">
          The best quality goods and services for your money ...
        </p>
      </div>
    </div>
    <div class="home__body__preview py-11 px-4">
      <h2 class=" font-bold text-xl  mb-5">
        Welcome To The Gold Gem
      </h2>
      <p class="w-10/12">
        With our affiliated strong institutions, we provide training on
        security, health care and entrepreneurship. We also assist professionals
        and skilled persons to find jobs locally and abroad to meet the quality
        standard of services.
        <router-link to="/about">Read More</router-link>
      </p>
    </div>
    <div class="home__body__preview mt-11 py-12 px-4">
      <h2 class="font-bold text-xl mb-5">Can We Help!</h2>
      <p class="w-10/12">
        Getting access to and employing the right, skillful staff with the
        correct mindset is a crucial part of driving your business forward. Our
        team of professionals has a well-earned reputation for successful,
        sustainable recruitment.
        <router-link to="/recruitment">Read More</router-link>
      </p>
    </div>
    <Footer />
  </div>
</template>

<script>
import InfoCaret from "@/components/InfoCaret";
import rect from "@/assets/rect.jpg";
import pub from "@/assets/pub.jpg";
import imp from "@/assets/imp.jpg";
import ec from "@/assets/ec.png";
import Footer from "@/components/Footer";
import Slider from "@/components/Slider";

export default {
  name: "Home",
  data() {
    return {
      imageList: [rect, pub, imp, ec],
    };
  },
  components: {
    InfoCaret,
    Footer,
    Slider,
  },
  methods: {
    goToRoute(name) {
      this.showMenu = false;
      this.$router.push({ name }).catch(() => {});
    },
  },
};
</script>

<style scoped>
.home {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.home__image {
  width: 100%;
}

.home__body {
  width: 1000px;
  margin-top: 20px;
}
.home__body__InfoCaret {
  display: flex;
  justify-content: space-evenly;
}
.home__body__offers-title {
  color: #404c60;
  font-size: 30px;
  font-weight: 500;
}
.home__body__text {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.home__body__text p {
  font-size: 30px;
  width: 500px;
  font-weight: bold;
}
.home__body__preview a {
  color: #404c60;
}
.home__body__preview {
  background-color: #404c600d;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.home__body__preview p {
  color: black;
  font-size: 25px;
}
@media only screen and (max-width: 900px) {
  .home__body {
    width: 100%;
  }
}
@media only screen and (max-width: 860px) {
  .home__body__InfoCaret a:last-child {
    display: none;
  }
}
@media only screen and (max-width: 768px) {
  .home__body__InfoCaret a:first-child {
    display: none;
  }
  .home__body__text {
    padding: 0 10px;
  }
  .home__body__preview {
    box-sizing: border-box;
  }
  .home__body__preview p {
    width: 100%;
    box-sizing: border-box;
    line-height: 1.7;
  }
}

@media only screen and (max-width: 600px) {
  .home__body {
    width: 100%;
  }
  .home__body__InfoCaret {
    display: inline-flex;
    flex-direction: column;
  }
  .home__body__InfoCaret a {
    margin-bottom: 10px;
  }
  .home__body__InfoCaret a:last-child,
  .home__body__InfoCaret a:first-child {
    display: block;
  }
}
</style>
